import * as React from "react";

import IncorporationProcess from 'src/containers/3a Incorporation/3a';

export default () => {
  return <IncorporationProcess type="sprout" paymentAmount={7250} />;
}